import styled from "styled-components";
import SelectIcon from "@/styles/assets/svg/icon_polygon_down.svg";

interface InputsStyleProps {
  $direction: "row" | "column";
  $color: string;
}

interface InputErroredProps {
  $errored?: boolean;
}

export const InputBox = styled.div<InputsStyleProps>`
  position: relative;
  display: flex;
  flex-direction: ${(props) => props.$direction};
  gap: 12px;

  &:has(input[type="text"]:focus),
  &:has(input[type="password"]:focus),
  &:has(input[type="date"]:focus) {
    &::before {
      width: 100%;
    }
  }

  &:has(input[type="text"]:not(:placeholder-shown)),
  &:has(input[type="password"]:not(:placeholder-shown)) {
    &::before {
      width: 100%;
    }
  }

  input {
    &[type="text"],
    &[type="password"],
    &[type="date"] {
      width: 100%;
      height: 48px;
      padding: 0 12px;
      font-size: 1.6rem;
      font-weight: 300;
      font-family: "Pretendard";
      border-radius: 10px;
      outline: none;
      border: 1px solid ${(props) => props.theme.colors.black12};

      &::placeholder {
        color: ${(props) => props.theme.colors.black38};
        font-family: "Pretendard";
        font-size: 1.4rem;
        font-weight: 300;
      }
    }
  }

  textarea {
    padding: 12px;
    font-size: 1.6rem;
    font-weight: 300;
    font-family: "Pretendard";
    line-height: 140%;
    border: 1px solid ${(props) => props.theme.colors.black12};
    border-radius: 10px;
    outline: none;
    resize: none;

    &::placeholder {
      color: ${(props) => props.theme.colors.black38};
      font-family: "Pretendard";
      font-size: 1.4rem;
      font-weight: 300;
    }
  }

  div.select-wrapper {
    position: relative;

    select {
      width: 100%;
      height: 48px;
      padding: 0 12px;
      border: 1px solid ${(props) => props.theme.colors.black12};
      border-radius: 10px;
      font-size: 1.6rem;
      font-weight: 300;
      font-family: "Pretendard";
      appearance: none;
      -webkit-appearance: none;
      outline: none;
      color: ${(props) => props.theme.colors.black70};

      option:disabled {
        color: ${(props) => props.theme.colors.black38};
      }
    }

    &::after {
      content: "";
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      width: 12px;
      height: 12px;
      background: url(${SelectIcon}) no-repeat center center;
      background-size: contain;
      pointer-events: none;
    }
  }
`;
export const InputLabel = styled.label<InputsStyleProps>`
  color: ${(props) => props.$color};
  font-size: 1.6rem;
  font-family: "Pretendard";

  span {
    color: ${(props) => props.theme.colors.destructive100};
  }
`;

export const ErroredText = styled.p<InputErroredProps>`
  position: absolute;
  bottom: -31px;
  padding-left: 6px;
  color: ${(props) =>
    props.$errored
      ? props.theme.colors.destructive100
      : props.theme.colors.tagGreen100};
  font-size: 1.2rem;
  margin: 10px 0;
`;
